<script>
  import Select from "svelte-select";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();
  export let label;
  export let items = [];
  $: mappedItems = items.map((i) => {
    return { value: i.key, label: i.value };
  });
  export let value = "";
  export let widthClass = "col-md-12";
  let selectedItem;

  let initialSet = false;
  $: triggerSetSelected = setSelected(value, mappedItems);

  function setSelected(cid) {
    if (!mappedItems) return;
    if (cid && (!selectedItem || selectedItem.value != cid)) {
      selectedItem = mappedItems.find((i) => i.value == value);
    } else {
      selectedItem == null;
    }
    window.setTimeout(() => {
      initialSet = true;
    }, 100);
  }

  $: triggerSetValue = setValue(selectedItem, mappedItems);
  function setValue(selected) {
    var bubble = false;
    if ((selected && selected.value != value) || (!selected && value))
      bubble = true;
    if (selected) {
      value = selected.value;
    } else {
      value = null;
    }
    if (bubble) bubbleChange();
  }
  function bubbleChange() {
    if (!initialSet) return;
    dispatch("blur", null);
  }
</script>

{#if label}
  <label for="selectbox">{label}</label>
{/if}
<Select
  bind:items={mappedItems}
  bind:selectedValue={selectedItem}
  id="selectbox"
  class="form-control {widthClass}"
  itemFilter={(label, filterText, option) => {
    return !filterText
      .split(" ")
      .some((word) => !label.toLowerCase().includes(word.toLowerCase()));
  }}
/>

<style>
</style>
